const esMX = {
  pages: {
    index: {
      h1: "SmartRent.com Página principal",
      button: "Un botón",
    },
  },
}

export default esMX
